import FavoriteComponent from '../components/favorite/favorite'

const Favorite = () => <FavoriteComponent />

export default Favorite;